import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { useState } from "react";
import { Spin, Typography } from 'antd';

import { useUserStore } from "../../../store/useUser";
import { getFromGoogleId } from "../../../service/book";
import useHeader from "../../../hooks/useHeader";
import { BookComponent } from "./options";
import Button from "../../../components/Button/Button";

import Modal from "../../../components/Modal/Modal";
import AddBookToBookcaseModal from "../../../container/Modal/Modals/AddBookOnBookcase/AddBookOnBookcase";
import { addBookToUserBookcaseByGoogleId, addBookToClubBookcaseByGoogleId } from "../../../service/bookcase";
import { createErrorNotification, createSuccessNotification } from "../../../service/notification";
import { StateBook } from "../../../models/books";

import styles from './Book.module.scss';
import { AddBookToBookcaseButton } from "./AddBookToBookcaseButton";

const { Paragraph } = Typography;

function GoogleBookInfo() {
  const { id: bookId } = useParams();

  const [loading, setLoading] = useState(false);

  const userId = useUserStore(state => state?.id);
  const profile = useUserStore(state => state.profile)
  const club = useUserStore(state => state.club)

  const { data: book, isFetching } = useQuery(
    ['book', bookId],
    () => getFromGoogleId(bookId),
    { refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false }
  );

  useHeader({ header: book?.name });

  const handleAddBookcase = async (params: {
    id: number | undefined;
    values: { state: StateBook; score: number };
  }) => {
    const { id, values } = params;

    const addBookcaseFunction = club && club.id && ['Mediador', 'Criador'].includes(profile)
      ? addBookToClubBookcaseByGoogleId
      : addBookToUserBookcaseByGoogleId

    try {
      const { error, success } = await addBookcaseFunction(id, bookId, values);
      setLoading(false);

      if (error) {
        return createErrorNotification('Erro ao adicionar na estante. Tente novamente mais tarde.');
      }

      return createSuccessNotification('Livro adicionado na estante.');
    } catch (error) {
      setLoading(false);
      return createErrorNotification('Erro ao adicionar na estante. Tente novamente mais tarde.');
    }
  };

  const addToBookcase = async (values: { state: StateBook; score: number }) => {
    if (!userId) return

    const id = (club && ['Mediador', 'Criador'].includes(profile)) ? club.id : userId

    return handleAddBookcase({ id, values });
  };

  return (
    <Spin spinning={isFetching}>
      <section className={styles.book}>
        {!!book && <BookComponent
          author={book?.author}
          imageLink={book?.imageLink}
          genres={[]}
          name={book?.name}
          page={book?.page}
          key={book?.idGoogle || book?.id}
        />
        }

        <Modal
          renderToggle={({ toggleModal }) =>
            <AddBookToBookcaseButton
              loading={loading}
              onClick={toggleModal}
            />
          }
        >
          {({ setOpen }) => {
            return (
              <AddBookToBookcaseModal onClick={(values) => {
                addToBookcase(values)
                setOpen(false)
              }} />
            )
          }}
        </Modal>
      </section>
      <section className={styles.sinopse}>
        <h2><strong>Sinopse do livro</strong></h2>
        <Paragraph ellipsis={{ rows: 2, expandable: true, symbol: 'mais', }}>
          {book?.description || ''}
        </Paragraph>
      </section>
    </Spin>
  )
}

export default GoogleBookInfo;